import React from "react";
import "../App.css";

const ClusterOne = () => {
  return (
    <div className="cluster-one-container">
      <div className="airtable-form-container">
        <iframe
          title="Cluster One"
          className="airtable-embed"
          src="https://airtable.com/embed/appvXYtQVYa47TcNx/pagDEoSqTFR8do4te/form"
          width="100%"
          height="653"
          style={{ background: "transparent", border: "1px solid #ccc" }}
        ></iframe>
      </div>
    </div>
  );
};

export default ClusterOne;
